const FAQ = () => {
  return (
    <iframe
      title="FAQ Embed"
      src="https://scribehow.com/page-embed/FAQs__I-8ytKaPQ_SVlfAv7LXoiw"
      style={{
        border: 0,
        height: '100%',
        borderRadius: '4px',
      }}
    />
  );
};

export default FAQ;
